import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Stack, StackDivider, useControllableState, useMultiStyleConfig, } from '@chakra-ui/react';
import { CalendarAria, CalendarPanel, CalendarProvider, CalendarStylesProvider, CalendarTodayButton, } from './CalendarBase';
export const Calendar = forwardRef(({ value, onChange, onMonthChange, onYearChange, defaultValue, showTodayButton = true, ...props }, initialFocusRef) => {
    const styles = useMultiStyleConfig('Calendar', props);
    const [internalValue, setInternalValue] = useControllableState({
        value,
        onChange,
        defaultValue,
    });
    return (_jsx(CalendarProvider, { ...props, selectedDates: internalValue ?? undefined, onSelectDate: setInternalValue, onMonthChange: onMonthChange, onYearChange: onYearChange, children: _jsxs(CalendarStylesProvider, { value: styles, children: [_jsx(CalendarAria, {}), _jsxs(Stack, { spacing: 0, divider: _jsx(StackDivider, {}), sx: styles.container, children: [_jsx(CalendarPanel, { ref: initialFocusRef }), showTodayButton && _jsx(CalendarTodayButton, {})] })] }) }));
});
Calendar.displayName = 'Calendar';
